module.exports = __webpack_public_path__ + "img/c9.e6243601.png";